<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">Would you like to create <strong>{{data}}__</strong>?</p>
    <button type="button" @click="create" class="btn btn-fill btn-info">
      Yes
    </button>
    <button type="button" @click="closeModal" class="btn btn-fill btn-info">
      No
    </button>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        addCity: false
      }
    },
    methods: {
      create () {
        this.addCity = true
        this.$eventHub.$emit('show-modal-6', 'City', { name: this.data }, '700px')
      },
      closeModal () {
        this.$emit('close')
      }
    },
    destroyed() {
      if (!this.addCity) {
        this.$eventHub.$emit('noCitySaved')
      }
    }
  }
</script>
